import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SkipModalService {
  isSkip = new Subject();
  isSuccess = new Subject();
}
